/**
 * The lead forms' company field label (Thomas, Oct 6 2026): "Company" alone
 * read as business-only, and churches, schools and nonprofits book too. The
 * box stays required, since an empty or junk company is part of the spam
 * defense.
 */
export const COMPANY_LABEL = 'Company/Organization';
